import { render, staticRenderFns } from "./PlatformStatistics.vue?vue&type=template&id=cb84da22&scoped=true"
import script from "./PlatformStatistics.vue?vue&type=script&lang=js"
export * from "./PlatformStatistics.vue?vue&type=script&lang=js"
import style0 from "./PlatformStatistics.vue?vue&type=style&index=0&id=cb84da22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb84da22",
  null
  
)

export default component.exports